import _ from "underscore";

import Backdraft from "backdraft-app/src/backdraft";
import coreIntegrationTitleTemplate from "./integration_modals/core_integration_title.jst";
import certifiedIntegrationTitleTemplate from "./integration_modals/certified_integration_title.jst";

Backdraft.plugin("IntegrationModals", function(plugin) {
  plugin.exports({
    certifiedIntegrationTitleTemplate
  });

  plugin.initializer(function(app) {
    app.view.modal("CoreIntegrationModalBase", {
      title: function() {
        return coreIntegrationTitleTemplate({ model: this.model });
      },

      subtitle: function() {
        return this.model.get("modal_subtitle");
      },

      documentation: function() {
        return this.model.get("documentation_link");
      }
    });

    app.view.modal("CoreIntegrationModal", "CoreIntegrationModalBase", {
      body: function() {
        return this.model.get("modal_text");
      },

      buttons: function() {
        var self = this;
        return [
          {
            text:      "Cancel",
            className: "btn-secondary",
            close:     true
          },
          {
            text:      "Ask a Question",
            className: "btn-primary",
            click:     function() {
              self.close();
              var modal = new app.Views.CoreIntegrationQuestionModal({ model: self.model });
              modal.render();
            }
          },
          {
            text:      "Purchase...",
            className: "btn-primary",
            click:     function() {
              self.close();
              var modal = new app.Views.CoreIntegrationConfirmRequestModal({ model: self.model });
              modal.render();
            }
          }
        ];
      }
    });

    app.view.modal("CoreIntegrationConfirmRequestModal", "CoreIntegrationModalBase", {
      body: function() {
        return "<h3>Ready to integrate?</h3>" +
          "<p>Please click \"" + this.confirmButtonText() + "\" below to have an Invoca representative reach out to you with next steps for purchasing the " + this.model.get("name") + " integration.</p>" +
          "<h3>Have a question?</h3>" +
          "<p>Please <a href='" + app.config.urlConfig.contactSupportUrl + "' target='_blank'>contact</a> the Invoca Customer Success team for more information on this integration.</p>";
      },

      confirmButtonText: function() {
        return this.model.get('confirmButtonText') || "Confirm";
      },

      buttons: function() {
        var self = this;
        return [
          {
            text:      "Cancel",
            className: "btn-secondary",
            close:     true
          },
          {
            text:      this.confirmButtonText(),
            className: "btn-primary",
            click:     function() {
              // sync to server to send notification
              self.model.addToAccount();

              self.close();
              var modal = new app.Views.CoreIntegrationRequestConfirmationModal({ model: self.model });
              modal.render();
            }
          }
        ];
      }
    });

    app.view.modal("CoreIntegrationRequestConfirmationModal", "CoreIntegrationModalBase", {
      body: function() {
        return "<h3>Thank you for your request to integrate with " + this.model.get("name") + "!</h3>" +
          "<p>An Invoca representative will be in touch with you to walk through the next steps in adding this integration to your Invoca platform.</p>";
      },

      buttons: function() {
        return [
          {
            text:      "Close",
            className: "btn-secondary",
            close:     true
          }
        ];
      }
    });

    app.view.modal("CoreIntegrationQuestionModal", "CoreIntegrationModalBase", {
      body: function() {
        return "<h3>Have a question?</h3>" +
          "<p>Please <a href='" + app.config.urlConfig.contactSupportUrl + "' target='_blank'>contact</a> the Invoca Customer Success team for more information.</p>";
      },

      buttons: function() {
        return [
          {
            text:      "Close",
            className: "btn-secondary",
            close:     true
          }
        ];
      }
    });

    app.view.modal("CertifiedIntegrationModalBase", {
      title: function() {
        return certifiedIntegrationTitleTemplate({ model: this.model });
      },

      subtitle: function() {
        return this._copy().sub_title;
      },

      documentation: function() {
        return this.model.get("documentation_link");
      },

      _copy: function() {
        return this.model.toJSON();
      }
    });

    app.view.modal("CertifiedIntegrationModal", "CertifiedIntegrationModalBase", {
      body: function() {
        return this._copy().description;
      },

      buttons: function() {
        var self = this;
        return [
          {
            text:      "Cancel",
            className: "btn-secondary",
            close:     true
          },
          {
            text:      "Ask a Question",
            className: "btn-primary",
            click:     function() {
              self.close();
              var modal = new app.Views.CertifiedIntegrationQuestionModal({ model: self.model });
              modal.render();
            }
          },
          {
            text:      "Purchase...",
            className: "btn-primary",
            click:     function() {
              self.close();
              var modal = new app.Views.CertifiedIntegrationConfirmRequestModal({ model: self.model });
              modal.render();
            }
          }
        ];
      }
    });

    app.view.modal("CertifiedIntegrationConfirmRequestModal", "CertifiedIntegrationModalBase", {
      body: function() {
        var documentationInfo = _.isString(this.documentation()) ? ", or see the link below for more documentation" : "";
        return "<h3>Ready to integrate?</h3>" +
          "<p>Please click \"Confirm\" below to have an Invoca representative reach out to you with next steps for purchasing the " + this.model.get("name") + " integration.</p>" +
          "<h3>Have a question?</h3>" +
          "<p>Please <a href='" + app.config.urlConfig.contactSupportUrl + "' target='_blank'>contact</a> the Invoca Customer Success team for more information on this integration." +
          documentationInfo +
          ".</p>";
      },

      buttons: function() {
        var self = this;
        return [
          {
            text:      "Cancel",
            className: "btn-secondary",
            close:     true
          },
          {
            text:      "Confirm",
            className: "btn-primary",
            click:     function() {
              // sync to server to send notification
              self.model.addToAccount();

              self.close();
              var modal = new app.Views.CertifiedIntegrationRequestConfirmationModal({ model: self.model });
              modal.render();
            }
          }
        ];
      }
    });

    app.view.modal("CertifiedIntegrationRequestConfirmationModal", "CertifiedIntegrationModalBase", {
      body: function() {
        return "<h3>Thank you for your request to integrate with " + this.model.get("name") + "!</h3>" +
          "<p>An Invoca representative will be in touch with you to walk through the next steps in adding this integration to your Invoca platform.</p>";
      },

      buttons: function() {
        return [
          {
            text:      "Close",
            className: "btn-secondary",
            close:     true
          }
        ];
      }
    });

    app.view.modal("CertifiedIntegrationQuestionModal", "CertifiedIntegrationModalBase", {
      body: function() {
        return "<h3>Have a question?</h3>" +
          "<p>Please <a href='" + app.config.urlConfig.contactSupportUrl + "' target='_blank'>contact</a> the Invoca Customer Success team for more information.</p>";
      },

      buttons: function() {
        return [
          {
            text:      "Close",
            className: "btn-secondary",
            close:     true
          }
        ];
      }
    });
  });
});
